import { render } from "./Show.vue?vue&type=template&id=f76dbd94&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=f76dbd94&lang=css"
import "./Show.vue?vue&type=style&index=1&id=f76dbd94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76dbd94"]])

export default __exports__